import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const SEARCH_BLOG_LIST = 'SEARCH_BLOG_LIST' // 操作日志列表查询
const SEARCH_PAGE_LIST = 'SEARCH_PAGE_LIST' // 获取页面操作列表

const defaultState = Immutable.fromJS({
  blogList: {
    list: [],
    total: 0
  },
  pageList: []
})

export const blogAction = createActions({
  SEARCH_BLOG_LIST: async params => {
    const result = await fetch.post(`/log/searchLog`, params)
    return result
  },
  SEARCH_PAGE_LIST: async () => {
    const result = await fetch.post(`/log/searchOperations`)
    return result
  }
})

const reducer = handleActions(
  {
    [SEARCH_BLOG_LIST]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'blogList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [SEARCH_PAGE_LIST]: (state, action) => {
      let curState = state
      curState = curState.set(
        'pageList',
        new List(action.payload)
      )
      return curState
    }
  },
  defaultState
)

export default reducer
